export const pitchdeck = {
  seo: {
    title: "Bespire - Pitch Deck",
    description: "AI-natív creator platform európai alkotóknak",
    keywords: "creator platform, AI, európai piac, tartalomgyártók"
  },
  navigation: {
    summary: "Összefoglaló",
    market: "Piac",
    revenue: "Bevétel",
    product: "Termék",
    team: "Csapat",
    financial: "Pénzügyek",
    logoAlt: "Bespire logó"
  },
  hero: {
    title: "Bespire",
    subtitle: "AI-natív creator platform európai alkotóknak"
  },
  problem: {
    badge: "A probléma",
    title: "Miért van szükség a Bespire-re?",
    description: "Az európai tartalomgyártók nehézségekkel szembesülnek bevételeik kezelésében és növelésében.",
    points: [
      "Nincs egységes eszköz a bevételek kezelésére",
      "Bonyolult ÁFA és számlázási rendszerek",
      "Korlátozott lokalizált fizetési megoldások"
    ]
  },
  solution: {
    badge: "A megoldás",
    title: "Így segít a Bespire",
    description: "AI-vezérelt platform, amely percek alatt teljes értékű online jelenlétet épít.",
    features: [
      {
        title: "AI-builder",
        description: "Automatikus weboldal és ajánlatstruktúra építés AI segítségével"
      },
      {
        title: "Lokalizált fizetés",
        description: "EU-kompatibilis ÁFA kezelés és integrált fizetési megoldások"
      },
      {
        title: "Egyszerű kezelés",
        description: "Minden egy helyen - tartalmak, szolgáltatások, közösség"
      }
    ]
  },
  market: {
    badge: "Piaci lehetőség",
    title: "Hatalmas piac vár ránk",
    description: "Az európai creator economy dinamikusan növekszik.",
    stats: [
      {
        value: "2.4M",
        label: "Elérhető kreátor az EU-ban"
      },
      {
        value: "2.0Mrd €",
        label: "Teljes piac mérete évente"
      }
    ],
    trends: {
      title: "Piaci trendek",
      points: [
        "Az európai creator economy piaca 51 Mrd USD 2024-ben",
        "A micro-influencerek száma folyamatosan növekszik",
        "A kreátorok 40%-a aktívan monetizál"
      ]
    }
  },
  businessModel: {
    badge: "Bevételi modell",
    title: "Így keresünk pénzt",
    description: "Hibrid bevételi modell SaaS előfizetésekkel és tranzakciós díjakkal.",
    streams: [
      {
        percentage: "70%",
        title: "SaaS előfizetések",
        description: "Havi előfizetési díjak 50-100 USD kreátoronként"
      },
      {
        percentage: "30%",
        title: "Tranzakciós díjak",
        description: "4% átlagos díj a platformon lebonyolított eladásokból"
      }
    ]
  },
  traction: {
    badge: "Eddigiek",
    title: "Amit eddig elértünk",
    description: "Az elmúlt időszak legfontosabb mérföldkövei.",
    milestones: [
      {
        date: "2024 Q1",
        title: "Platform MVP",
        description: "Az első működő verzió elkészült AI-builderrel"
      },
      {
        date: "2024 Q2",
        title: "Első ügyfelek",
        description: "Pilot program indítása kiválasztott kreátorokkal"
      },
      {
        date: "2024 Q3",
        title: "Fizetési integráció",
        description: "EU-kompatibilis fizetési rendszer beüzemelése"
      }
    ]
  },
  team: {
    badge: "A csapat",
    title: "Kik vagyunk?",
    description: "Tapasztalt szakemberek a tech és creator világból.",
    members: [
      {
        name: "Alapító 1",
        role: "CEO & Co-founder",
        bio: "10+ év tapasztalat a tech startupok világában"
      },
      {
        name: "Alapító 2",
        role: "CTO & Co-founder",
        bio: "Korábbi tech lead vezető vállalatoknál"
      }
    ]
  },
  ask: {
    badge: "Tőkebevonás",
    title: "Mire van szükségünk?",
    description: "2M EUR seed befektetés 24 hónap runway biztosítására.",
    amount: "2M EUR",
    equity: "Max. 10% részesedés",
    valuation: "16M EUR",
    useOfFunds: {
      title: "Felhasználási terv",
      items: [
        {
          category: "Csapatépítés",
          percentage: "50-55%"
        },
        {
          category: "Marketing & Növekedés",
          percentage: "20-25%"
        },
        {
          category: "Infrastruktúra & AI",
          percentage: "15-20%"
        }
      ]
    }
  },
  contact: {
    title: "Vegyük fel a kapcsolatot",
    description: "Készen állsz, hogy közösen építsük a jövőt?",
    emailLabel: "Email",
    email: "hello@bespire.io",
    phoneLabel: "Telefon",
    phone: "+36 20 123 4567"
  },
  summary: {
    title: "Vezetői összefoglaló",
    mission: {
      title: "Küldetés",
      description: "A Bespire egy AI-natív creator platform, amely segít az európai és közel-keleti tartalomgyártóknak és menedzsereiknek abban, hogy néhány perc alatt teljes értékű, bevételtermelő online jelenlétet építsenek – lokalizált fizetéssel, számlázással és ajánlatokkal."
    },
    product: {
      title: "Jelenlegi termékállapot",
      ready: "Kész",
      readyItems: [
        "AI-builder (website + ajánlatstruktúra)",
        "EU-kompatibilis ÁFA kezelés",
        "Integrált online fizetés"
      ],
      nextMilestones: "Következő mérföldkövek",
      milestones: [
        "AI-értékesítési asszisztens (mit árulj, mennyiért, hogyan csomagold)",
        "Az AI-asszisztens skálázása (több nyelv, több vertikum, automatizált kampányok)"
      ]
    },
    keyNumbers: {
      title: "Fő számok (3 éves terv)",
      avgRevenue: "Átlagos platform árbevétel fizető kreatoronként",
      avgRevenueValue: "50–100 USD / hó",
      yearlyRevenue: "Éves árbevétel (SaaS + tranzakciós díj)",
      year1: "240k EUR",
      year2: "1,08M EUR",
      year3: "3,72M EUR",
      ebitda: "EBITDA",
      ebitdaYear1: "–110k EUR",
      ebitdaYear2: "+330k EUR",
      ebitdaYear3: "+2,22M EUR"
    },
    funding: {
      title: "Tőkebevonás",
      target: "Cél: ~2M EUR seed",
      equity: "Maximum feladott részesedés: 10%",
      valuation: "≈ 18M EUR post-money, ~16M pre-money",
      goal: "Cél: 24 hónap runway + erős növekedési marketing és AI-fejlesztés"
    }
  },
  revenue: {
    title: "Bevételi modell",
    saas: {
      title: "SaaS előfizetések",
      range: "50–100 USD/hó / kreator",
      starter: "Starter: alacsony belépő, limitált termékszám, alacsony AI kvóta",
      pro: "Pro: fő fókuszcsomag (~70 EUR/hó), több termék, több AI funkció",
      agency: "Agency: több kreator kezelése, extra riportok"
    },
    transaction: {
      title: "Tranzakciós jutalék",
      average: "Átlag 4%",
      free: "Free csomag: 9% fee (legmagasabb)",
      paid: "Fizetős csomagok: sávos, lefelé csökkenő díj"
    },
    addons: {
      title: "AI add-onok és szolgáltatások",
      credits: "Extra AI kreditek (videó script, workshop outline, email funnel, sales page)",
      services: "Done-with-you setup, ügynökségi csomagok"
    }
  },
  product: {
    title: "Termék & roadmap",
    current: {
      title: "Jelenleg kész",
      aiBuilder: {
        title: "AI-builder",
        features: [
          "Kérdés-válasz alapon felméri a kreator céljait, közönségét, erősségeit",
          "Összerak egy komplett weboldal-struktúrát, ajánlatcsomagokat és alap szöveget"
        ]
      },
      vat: {
        title: "ÁFA-kezelés és számlázási logika",
        description: "EU-s szabályoknak megfelelő ÁFA kalkuláció, számlázás különböző országokba"
      },
      payment: {
        title: "Online fizetés integráció",
        description: "EUR fokusszal, HU támogatással"
      }
    },
    next: {
      title: "Következő fő fejlesztések",
      phase1: {
        title: "AI-asszisztens (sales & ops) – 0–12 hónap",
        features: [
          "\"Mit adjak el?\" – ajánlat-stratégia, árazás, csomagolás",
          "Kampány-ötletek: launch naptár, akciók, poszt-ötletek",
          "\"Next best action\" javaslatok a valós adatok alapján"
        ]
      },
      phase2: {
        title: "AI-asszisztens skálázása – 12–36 hónap",
        features: [
          "Több nyelv (DE, PL, RO, stb.)",
          "Mélyebb vertikális specializáció (fitness, edukáció, business coachok, stb.)",
          "Félig autonóm kampányfuttatás (ajánlatok, landingek, e-mail sorozatok generálása)"
        ]
      }
    }
  },
  target: {
    title: "Célpiac & pozicionálás",
    personas: {
      title: "Fő personák",
      items: [
        "10–200k követős lifestyle, fitness, edukációs kreatorok Európa Euró-övezetében + HU-ban",
        "Online coachok, trénerek, tanácsadók (creator-jellegű működéssel)",
        "Talent managerek / ügynökségek, 10–50 kreatoros portfólióval"
      ]
    },
    positioning: {
      title: "Pozicionálás",
      aiNative: "AI-natív, all-in-one – nem csak webshop vagy link-in-bio, hanem komplett értékesítési rendszer",
      euroFirst: "Euro-first – árképzés, ÁFA, szabályozás, többnyelvűség, EUR-fókusz",
      agencyFriendly: "Ügynökség-barát – több kreator kezelése, riportok, revenue share"
    }
  },
  gtm: {
    title: "Go-to-market",
    subtitle: "Eurozóna + HU fókusz",
    firstWave: {
      title: "Első hullám",
      countries: "Magyarország + 3–4 Euro-zónás ország (pl. DE, AT, SK, SI) mint pilot",
      target: "Micro/mid-tier kreatorok, akik már árulnak vagy árulni terveznek digitális terméket"
    },
    channels: {
      title: "Csatornák",
      social: "Instagram/TikTok DM outreach, személyre szabott üzenetekkel",
      partnerships: "Partneri együttműködés kreator-ügynökségekkel, talent managerekkel",
      cases: "Esettanulmányok, \"from 0 to 5k/month\" típusú sztorik"
    },
    funnel: {
      title: "Monetizációs funnel",
      free: "Ingyenes csomag magasabb 9%-os fee-vel (gyors belépő, frikciómentes)",
      upsell: "Upsell Pro/Agency csomagra, ahogy nő a forgalom"
    }
  },
  financial: {
    title: "Pénzügyi terv",
    subtitle: "3 éves projekció",
    assumptions: {
      title: "Feltételezések",
      creators: "Fizető kreatorok év végén",
      year1: "500 kreator (1. év)",
      year2: "2 000 kreator (2. év)",
      year3: "6 000 kreator (3. év)",
      avgRevenue: "Átlag havi platform árbevétel: ~70 EUR / kreator",
      gmv: "GMV / kreator / év",
      gmvYear1: "3 000 EUR (1. év)",
      gmvYear2: "6 000 EUR (2. év)",
      gmvYear3: "10 000 EUR (3. év)",
      platformFee: "Átlagos platform fee: 4%"
    },
    revenue: {
      title: "Árbevétel",
      tableHeader: "Bevételi típus",
      saas: "SaaS előfizetések",
      transaction: "Tranzakciós díj",
      total: "Összesen",
      year1: "1. év",
      year2: "2. év",
      year3: "3. év"
    },
    costs: {
      title: "Költségek",
      year1Description: "core csapat, fejlesztés, infra, kezdeti marketing",
      year2Description: "csapatbővítés, erős GTM",
      year3Description: "skálázás, több ország, több nyelv"
    },
    ebitda: {
      title: "EBITDA",
      year1: "–110k EUR (1. év)",
      year2: "+330k EUR (2. év)",
      year3: "+2,22M EUR (3. év)"
    }
  },
  funding: {
    title: "Tőkebevonás – struktúra",
    target: "Célösszeg: kb. 2M EUR seed",
    equity: "Részesedés: max. 10% (nem megyünk ez fölé)",
    usage: {
      title: "Felhasználás",
      team: "50–55%: core csapat (CTO, fejlesztők, COO, részben marketing/growth)",
      acquisition: "20–25%: creator acquisition, paid és partner csatornák",
      infrastructure: "15–20%: infra, AI-költségek, compliance, tartalék"
    }
  },
  sources: {
    title: "Források",
    items: [
      {
        title: "The Largest Influencer Study in Europe in 2023",
        url: "https://influencity.com/resources/studies/the-largest-influencer-study-of-europe-2023/",
        description: "Európai influencer statisztikák és piaci adatok"
      },
      {
        title: "The Influencer Marketing Statistics For 2024",
        url: "https://sociallypowerful.com/post/influencer-marketing-statistics-2024-2",
        description: "Influencer marketing trendek és számok"
      },
      {
        title: "Europe Creator Economy Market Size & Outlook, 2024-2033",
        url: "https://www.grandviewresearch.com/horizon/outlook/creator-economy-market/europe",
        description: "Európai creator economy piaci elemzés"
      }
    ]
  },
  footer: {
    rights: "Minden jog fenntartva"
  }
};
